import { render, staticRenderFns } from "./SiloAlarmActiveDisplay.vue?vue&type=template&id=2ab2cb9d"
import script from "./SiloAlarmActiveDisplay.vue?vue&type=script&lang=js"
export * from "./SiloAlarmActiveDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports